import { gql } from '@apollo/client';

export const VAT_NUMBER_VALIDITY_QUERY = gql`
  query VatNumberValidityQuery($countryCode: String!, $vatNumber: String!) {
    magento2 {
      checkVatNumber(country_code: $countryCode, vat_number: $vatNumber) {
        isValid
      }
    }
  }
`;

export const ADDRESS_COUNTRIES = gql`
  query AddressCountriesQuery {
    magento2 {
      storeConfig {
        storeCode
        countriesRequireState
      }
      countries {
        id
        twoLetterAbbreviation
        fullNameLocale
        availableRegions {
          id
          code
          name
        }
      }
    }
  }
`;

export const CUSTOMER_NAME_QUERY = gql`
  query Customer {
    magento2 {
      customer {
        nativeId
        firstname
        lastname
        email
      }
    }
  }
`;
